// AUTO-GENERATED at build time by scripts/generateBuildInfo.js. Do not edit.
export const APP_VERSION = "3743d70";
export const BUILD_DATE = "16 Oct 2026, 7:47 pm";
